import request from "./request"

export const guildOverviewGet = () => request.get("/guild/overview_get")
export const availableGuildListGet = params => request.get("/guild/guild_list_get", { params })
export const guildInvitationReview = data => request.post("/guild/invitation_review", data)
export const guildMembershipRequestAdd = data => request.post("/guild/request_add", data)
